import { tokenAliasOrValue } from "./base";
import { z } from "zod";
export const DimensionUnit = z.enum([
    "Pixels",
    "Percent",
    "Rem",
    "Ms",
    "Raw",
    "Points",
]);
export const DimensionValue = z.object({
    unit: DimensionUnit,
    measure: z.number(),
});
export const DimensionTokenData = tokenAliasOrValue(DimensionValue);
